import React, { useState, useEffect } from 'react';
import { useGetAll } from '../hooks/PreregistroHook';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { RootState } from '../../../../../setup';
import {
  KTSVG,
  userHasRole,
  SimpleAlert,
  LoadingGrid,
  formatDateMonth,
  formatTime,
} from '../../../../../_mexablock/helpers';
import { Filter } from '../_modals/Filter';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import {
  downloadExcel,
  downloadPDF,
} from '../../../../service/reportes/PreRegistro';
import { parseAxiosError } from '../../../../service/reportes/AccountStatment';

let fechaActual = new Date();
let fecha_inicio_init = new Date(
  fechaActual.getFullYear(),
  fechaActual.getMonth() - 1,
  1
);
let fecha_fin_init = new Date();

const View: React.FC = () => {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { roles: userRoles } = user;
  const showFilterCode = userHasRole(
    [
      'ADMIN_MEXABLOCK',
      'ADMIN_PARTNER',
      'CALL_CENTER',
      'REPORTES',
      'ADMIN_COMPANY',
    ],
    userRoles
  );
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    offer_id: 0,
    code: '',
    init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
    end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
    filter: 0,
  });
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loadingDownloadExcel, setloadingDownloadExcel] = useState(false);

  useEffect(() => {
    if (data.length) {
      setloadingDownload(false);
      setloadingDownloadExcel(false);
    } else {
      setloadingDownload(true);
      setloadingDownloadExcel(true);
    }
  }, [data]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      offer_id: 0,
      code: '',
      init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
      end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
      filter: 0,
    });
  };

  const statusPre = (row: any) => {
    switch (row) {
      case 1:
        return (
          <span className="fw-normal badge badge-light-warning text-center d-inline-block">
            Pendiente
          </span>
        );
      case 2:
        return (
          <span className="fw-normal badge badge-light-primary text-center d-inline-block">
            En proceso
          </span>
        );
      case 3:
        return (
          <span className="fw-normal badge badge-light-success text-center d-inline-block">
            Exitoso
          </span>
        );

      case 4:
        return (
          <span className="fw-normal badge badge-light-danger text-center d-inline-block">
            Error
          </span>
        );

      case 7:
        return (
          <span className="fw-normal badge badge-light-success text-center d-inline-block">
            Activada
          </span>
        );

      case 8:
        return (
          <span className="fw-normal badge badge-light-primary text-center d-inline-block">
            Portada
          </span>
        );
    }
  };

  const columns: any = [
    {
      id: 'Fecha',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => row.Fecha,
      sortable: true,
      width: '120px',
    },
    {
      id: 'Hora',
      name: <div className="fw-bolder text-muted me-5">Hora</div>,
      selector: (row: any) => row.Hora,
      sortable: true,
      width: '120px',
    },
    {
      id: 'id',
      name: <div className="fw-bolder text-muted me-5">ID</div>,
      selector: (row: any) => row.ID,
      sortable: true,
    },
    {
      id: 'Cliente',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => (row.Cliente ? row.Cliente : ''),
      width: '250px',
      sortable: true,
    },
    {
      id: 'operacion',
      name: <div className="fw-bolder text-muted me-5">Operación</div>,
      selector: (row: any) => (row.Operación ? row.Operación : ''),
      sortable: true,
      width: '200px',
    },

    {
      id: 'oferta',
      name: <div className="fw-bolder text-muted me-5">Oferta</div>,
      selector: (row: any) => (row.Oferta ? row.Oferta : ''),
      sortable: true,
      width: '180px',
    },
    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) => (row.Monto ? `$ ${row.Monto}` : ''),
      sortable: true,
    },
    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => (row.ICCID ? row.ICCID : 'Pendiente'),
      sortable: true,
      width: '200px',
    },
    {
      id: 'MSISDN',
      name: <div className="fw-bolder text-muted me-5">MSISDN</div>,
      selector: (row: any) => (row.MSISDN ? row.MSISDN : 'Pendiente'),
      width: '120px',
      sortable: true,
    },

    {
      id: 'Usuario',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) => {
        return row.Usuario ? row.Usuario : '';
      },
      width: '250px',
      sortable: true,
    },

    {
      id: 'status',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.EstatusID,
      cell: (row: any) => statusPre(row.EstatusID),
      sortable: true,
    },
  ];

  const handleDownloadPDF = () => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(initFilterValues)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  const handleDownloadExcel = () => {
    setloadingDownloadExcel(true);
    setTimeout(() => {
      downloadExcel(initFilterValues)
        .then(() => {
          setloadingDownloadExcel(false);
        })
        .catch(async (error) => {
          setloadingDownloadExcel(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
                showFilterCode={showFilterCode}
              />
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  <button
                    className="btn btn-sm btn-light-success"
                    disabled={loadingDownloadExcel}
                    onClick={() => handleDownloadExcel()}
                  >
                    {loadingDownloadExcel && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil029.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>

                  <button
                    className="btn btn-sm btn-light-danger ms-5"
                    disabled={loadingDownload}
                    onClick={handleDownloadPDF}
                  >
                    {loadingDownload && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil030.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
